import React from 'react';
import PropTypes from 'prop-types';
import {withStyles, Button} from "@material-ui/core";
import {themeTypeToBool} from '../../utils/helpers';
import t from "../../languages/pl";

const useStyles = theme => ({
    buttonOk: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.primary.main
    },
    buttonLabel: {
        color: "#FFF"
    }
});

const CancelAcceptForm = ({
                              classes,
                              onCancel,
                              onSubmit,
                              disableSubmit = false,
                              acceptName,
                              cancelName = null,
                              showSubmitButton = true
                          }) => {
    return (
        <React.Fragment>
            <div style={{
                display: 'flex',
                alignItems: "center",
                justifyContent: 'space-between',

            }}>
                <div style={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: 'flex-end',
                    gap: '8px'
                }}>
                    <Button
                        variant="contained"
                        onClick={onCancel}
                        color="secondary"
                    >
                        {cancelName ? cancelName : t.cancel}
                    </Button>
                    {showSubmitButton &&
                        <Button
                            variant="contained"
                            color="primary"
                            classes={{containedPrimary: classes.buttonOk, label: classes.buttonLabel}}
                            onClick={onSubmit}
                            disabled={disableSubmit}
                        >
                            {acceptName ? acceptName : t.ok}
                        </Button>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default withStyles(useStyles)(CancelAcceptForm);

CancelAcceptForm.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    disableSubmit: PropTypes.bool,
    acceptName: PropTypes.string,
    cancelName: PropTypes.string,
    showSubmitButton: PropTypes.bool,
};
